import notificationRepository from '../../repositories/notification/internal.notification.repository';

const defaultPageSize = 5;

const normalize = (notification = {}) => ({
    ...notification,
    createdAt: notification.createdAt || notification.created || null,
});

const dedupeById = (notifications) => {
    const seenIds = new Set();

    return notifications.filter(notification => {
        if (seenIds.has(notification.id))
            return false;

        seenIds.add(notification.id);
        return true;
    });
}

const mergeHead = (currentNotifications = [], headNotifications = []) =>
    dedupeById([...headNotifications, ...currentNotifications]);

const appendPage = (currentNotifications = [], pageNotifications = []) =>
    dedupeById([...currentNotifications, ...pageNotifications]);

const removeByIds = (notifications = [], ids = []) =>
    notifications.filter(notification => !ids.includes(notification.id));

const findMine = async ({ pageIndex = 0, pageSize = defaultPageSize } = {}) => {

    const { data } = await notificationRepository.findMine({ pageIndex, pageSize });

    const pagination = data?.pagination || {};
    const currentPageIndex = Number(pagination.pageIndex ?? pageIndex);

    return {
        notifications: (data?.notifications || []).map(normalize),
        pendingCount: Number(data?.pendingCount || 0),
        pageIndex: currentPageIndex,
        hasMore: currentPageIndex + 1 < Number(pagination.pages || 0),
    };
}

const readAll = async () =>
    notificationRepository.readAll();

const read = async (id) =>
    notificationRepository.read(id);

const clearAll = async () =>
    notificationRepository.clearAll();

export default {
    normalize,
    mergeHead,
    appendPage,
    removeByIds,
    findMine,
    readAll,
    read,
    clearAll,
}
